<div class="container">
  <div class="celo-dialog-header">
    <h2 mat-dialog-title class="title">Are you enjoying Celo?</h2>
    <button
      mat-icon-button
      aria-label="Close"
      class="close celo-dialog-close"
      mat-dialog-close
      [disabled]="isSubmitting"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="ratings" [attr.aria-busy]="isSubmitting">
    <button
      type="button"
      class="rating"
      aria-label="No"
      [disabled]="isSubmitting"
      (click)="select('negative')"
    >
      <img src="/assets/icons/thumbs-down.svg" alt="" width="30" height="30" />
    </button>
    <button
      type="button"
      class="rating"
      aria-label="Yes"
      [disabled]="isSubmitting"
      (click)="select('positive')"
    >
      <img src="/assets/icons/thumbs-up.svg" alt="" width="30" height="30" />
    </button>
  </div>
</div>
